<app-header title="Manage Campaigns"></app-header>
<div class="container pt-5 mt-5">
    <div class="d-flex justify-content-between mb-2">
        <div class="campaign__title">Your Campaigns</div>
        <div class="campaign__action-list d-flex">
            <button class="btn btn--paybee btn-sm modal-confirm-button" (click)="createNewCampaign()">New Campaign</button>
        </div>
    </div>
</div>
<mdb-tabs #tabs class="mdb-tabs mdb-tabs--campaign-list" (activeTabChange)="onTabChange($event)" >
    <mdb-tab title="Active">
        <div style="background-color: #FFFFFF;">
            <div class="container mb-5">
                <div class="w-100" style="height: 1px"></div>
                <div class="campaign mt-3" style="border-bottom: 1px solid #EEEFF2" *ngFor="let campaign of activeCampaignList">
                    <div class="campaign__name d-flex align-items-center mb-2">
                        <div class="campaign__name text-truncate">{{campaign.name}}</div>
                    </div>
                    <div class="campaign_body pb-3">
                        <div class="row">
                            <div class="col-sm-3 col-lg-4">
                                <img [src]="getCampaignImageUrl(campaign)" alt="" class="campaign__image w-100" />
                            </div>
                            <div class="col-sm-9 col-lg-8 d-flex justify-content-between">
                                <div class="w-100">
                                    <div class="campaign__characteristic d-flex align-items-center">
                                        <div class="campaign__characteristic-name mr-2">Status</div>
                                        <ng-container [ngSwitch]="campaign.status">
                                            <ng-container *ngSwitchCase="0">
                                                @if(!campaign.isDefault){
                                                    <div
                                                        class="campaign__characteristic-value campaign__characteristic-value--orange position-relative px-2 py-1"
                                                    >
                                                        <div 
                                                            class="campaign__characteristic-background campaign__characteristic-background--orange position-absolute h-100 w-100">
                                                        </div>
                                                        Hidden
                                                    </div>
                                                } @else{
                                                    <div
                                                        class="campaign__characteristic-value campaign__characteristic-value--green position-relative px-2 py-1"
                                                    >
                                                        <div class="campaign__characteristic-background campaign__characteristic-background--green position-absolute h-100 w-100"></div>
                                                        Active
                                                    </div>
                                                }
                                            </ng-container>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="1"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Expired
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="2"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Deactivated
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--yellow position-relative px-2 py-1"
                                                *ngSwitchCase="3"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--yellow position-absolute h-100 w-100"></div>
                                                Not Started
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="5"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Archived
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Raised</div>
                                        <div class="campaign__characteristic-value">{{campaign.raised | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Pledges</div>
                                        <div class="campaign__characteristic-value">{{campaign.pledged | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Type</div>
                                        <div class="campaign__characteristic-value">{{ getCampaignType(campaign) }}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex" *ngIf="campaign?.campaignTypeData?.winnerUser">
                                        <div class="campaign__characteristic-name mr-2">Winner</div>
                                        <div class="campaign__characteristic-value">
                                            <div
                                                *ngIf="campaign.campaignTypeData.winnerUser?.name"
                                            >{{campaign.campaignTypeData.winnerUser.name}}</div>
                                            <div
                                                *ngIf="campaign.campaignTypeData.winnerUser?.email"
                                            >{{campaign.campaignTypeData.winnerUser.email}}</div>
                                        </div>
                                    </div>
                                    <div class="campaign__action-list d-flex">
                                        <button
                                            type="button"
                                            class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                            (click)="onEditCampaign(campaign)"
                                        >Edit</button>
                                        <ng-container [ngSwitch]="campaign.status">
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="0"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="1"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="2"
                                                (click)="activateCampaign(campaign)"
                                            >Activate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="3"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="5"
                                                (click)="activateCampaign(campaign)"
                                            >Activate</button>
                                        </ng-container>
                                            <app-actions-popover-campaign [campaign]="campaign"></app-actions-popover-campaign>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center flex-column" style="min-width: 150px;">
                                    <a class="campaign__qr-code mb-3" target="_blank" [href]="getQRUrl(campaign)">
                                        <img class="image" [src]="getQRImageUrl(campaign)" />
                                        <img src="images/powered_paybee.png" />
                                    </a>
                                    <app-shared-link-campaign-popover [campaign]="campaign"></app-shared-link-campaign-popover>

                                    <button
                                        type="button"
                                        class="campaign__action btn btn--paybee btn--outline-transparent w-100"
                                        (click)="onClickDownload(campaign)"
                                    >
                                        <span>QR Code</span>
                                        <i class="fas fa-download ml-1"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mdb-tab>
    <mdb-tab title="Not Active">
        <div style="background-color: #FFFFFF;">
            <div class="container">
                <div class="w-100" style="height: 1px"></div>
                <div class="campaign mt-3" style="border-bottom: 1px solid #EEEFF2" *ngFor="let campaign of notActiveCampaignList">
                    <div class="campaign__name d-flex align-items-center mb-2">
                        <div class="campaign__name text-truncate">{{campaign.name}}</div>
                    </div>
                    <div class="campaign_body pb-3">
                        <div class="row">
                            <div class="col-sm-3 col-lg-4">
                                <img [src]="getCampaignImageUrl(campaign)" alt="" class="campaign__image w-100" />
                            </div>
                            <div class="col-sm-9 col-lg-8 d-flex justify-content-between">
                                <div class="w-100">
                                    <div class="campaign__characteristic d-flex align-items-center">
                                        <div class="campaign__characteristic-name mr-2">Status</div>
                                        <ng-container [ngSwitch]="campaign.status">
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--green position-relative px-2 py-1"
                                                *ngSwitchCase="0"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--green position-absolute h-100 w-100"></div>
                                                Active
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="1"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Expired
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="2"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Deactivated
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--yellow position-relative px-2 py-1"
                                                *ngSwitchCase="3"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--yellow position-absolute h-100 w-100"></div>
                                                Not Started
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="5"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Archived
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Raised</div>
                                        <div class="campaign__characteristic-value">{{campaign.raised | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Pledges</div>
                                        <div class="campaign__characteristic-value">{{campaign.pledged | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Type</div>
                                        <div class="campaign__characteristic-value">{{ getCampaignType(campaign) }}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex" *ngIf="campaign?.campaignTypeData?.winnerUser">
                                        <div class="campaign__characteristic-name mr-2">Winner</div>
                                        <div class="campaign__characteristic-value">
                                            <div
                                                *ngIf="campaign.campaignTypeData.winnerUser?.name"
                                            >{{campaign.campaignTypeData.winnerUser.name}}</div>
                                            <div
                                                *ngIf="campaign.campaignTypeData.winnerUser?.email"
                                            >{{campaign.campaignTypeData.winnerUser.email}}</div>
                                        </div>
                                    </div>
                                    <div class="campaign__action-list d-flex">
                                        <button
                                            type="button"
                                            class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                            (click)="onEditCampaign(campaign)"
                                        >Edit</button>
                                        <ng-container [ngSwitch]="campaign.status">
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="0"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="1"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="2"
                                                (click)="activateCampaign(campaign)"
                                            >Activate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="3"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="5"
                                                (click)="activateCampaign(campaign)"
                                            >Activate</button>
                                        </ng-container>
                                        <app-actions-popover-campaign [campaign]="campaign"></app-actions-popover-campaign>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center flex-column" style="min-width: 150px;">
                                    <a class="campaign__qr-code mb-3" target="_blank" [href]="getQRUrl(campaign)">
                                        <img class="image" [src]="getQRImageUrl(campaign)" />
                                        <img src="images/powered_paybee.png" />
                                    </a>
                                    <app-shared-link-campaign-popover [campaign]="campaign"></app-shared-link-campaign-popover>
                                    <button
                                        type="button"
                                        class="campaign__action btn btn--paybee btn--outline-transparent w-100"
                                        (click)="onClickDownload(campaign)"
                                    >
                                        <span>QR Code</span>
                                        <i class="fas fa-download ml-1"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mdb-tab>
    <mdb-tab title="Archived">
        {{access}}
        <div style="background-color: #FFFFFF;">
            <div class="container">
                <div class="w-100" style="height: 1px"></div>
                <div class="campaign mt-3" style="border-bottom: 1px solid #EEEFF2" *ngFor="let campaign of archivedCampaignList">
                    <div class="campaign__name d-flex align-items-center mb-2">
                        <div class="campaign__name text-truncate">{{campaign.name}}</div>
                    </div>
                    <div class="campaign_body pb-3">
                        <div class="row">
                            <div class="col-sm-3 col-lg-4">
                                <img [src]="getCampaignImageUrl(campaign)" alt="" class="campaign__image w-100" />
                            </div>
                            <div class="col-sm-9 col-lg-8 d-flex justify-content-between">
                                <div class="w-100">
                                    <div class="campaign__characteristic d-flex align-items-center">
                                        <div class="campaign__characteristic-name mr-2">Status</div>
                                        <ng-container [ngSwitch]="campaign.status">
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--green position-relative px-2 py-1"
                                                *ngSwitchCase="0"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--green position-absolute h-100 w-100"></div>
                                                Active
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="1"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Expired
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="2"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Deactivated
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--yellow position-relative px-2 py-1"
                                                *ngSwitchCase="3"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--yellow position-absolute h-100 w-100"></div>
                                                Not Started
                                            </div>
                                            <div
                                                class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1"
                                                *ngSwitchCase="5"
                                            >
                                                <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                                Archived
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Raised</div>
                                        <div class="campaign__characteristic-value">{{campaign.raised | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Pledges</div>
                                        <div class="campaign__characteristic-value">{{campaign.pledged | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex">
                                        <div class="campaign__characteristic-name mr-2">Type</div>
                                        <div class="campaign__characteristic-value">{{ getCampaignType(campaign) }}</div>
                                    </div>
                                    <div class="campaign__characteristic d-flex" *ngIf="campaign?.campaignTypeData?.winnerUser">
                                        <div class="campaign__characteristic-name mr-2">Winner</div>
                                        <div class="campaign__characteristic-value">
                                            <div
                                                *ngIf="campaign.campaignTypeData.winnerUser?.name"
                                            >{{campaign.campaignTypeData.winnerUser.name}}</div>
                                            <div
                                                *ngIf="campaign.campaignTypeData.winnerUser?.email"
                                            >{{campaign.campaignTypeData.winnerUser.email}}</div>
                                        </div>
                                    </div>
                                    <div class="campaign__action-list d-flex">
                                        <button
                                            type="button"
                                            class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                            (click)="onEditCampaign(campaign)"
                                        >Edit</button>
                                        <ng-container [ngSwitch]="campaign.status">
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="0"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="1"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="2"
                                                (click)="activateCampaign(campaign)"
                                            >Activate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="3"
                                                (click)="deleteCampaign(campaign)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="5"
                                                (click)="activateCampaign(campaign)"
                                            >Activate</button>
                                        </ng-container>
                                        <app-actions-popover-campaign [campaign]="campaign" ></app-actions-popover-campaign>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center flex-column" style="min-width: 150px;">
                                    <a class="campaign__qr-code mb-3" target="_blank" [href]="getQRUrl(campaign)">
                                        <img class="image" [src]="getQRImageUrl(campaign)" />
                                        <img src="images/powered_paybee.png" />
                                    </a>
                                    <app-shared-link-campaign-popover [campaign]="campaign"></app-shared-link-campaign-popover>
                                    <button
                                        type="button"
                                        class="campaign__action btn btn--paybee btn--outline-transparent w-100"
                                        (click)="onClickDownload(campaign)"
                                    >
                                        <span>QR Code</span>
                                        <i class="fas fa-download ml-1"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mdb-tab>
    <mdb-tab>
        <ng-template mdbTabTitle>
            <app-text-popover
                [ngStyle]="{'display': popoverHTML == '' ? 'none' : 'flex'}"
                placement="bottom"
                type="custom" 
                size="small"                      
                title=""
                [buttonHTML]="popoverButtonHTML"
                [innerHTML]="popoverHTML"
            >
            </app-text-popover>
        </ng-template>
    </mdb-tab>
</mdb-tabs>
<!-- Access limited to certain campaigns.  -->